// import {
//   CompleteUserTbl,
//   TransactionSummaryView,
//   UserTbl,
// } from './gen_typings';

import { User } from 'api/bindings/User';
import { UserResponse } from 'api/bindings/UserResponse';

export * from './cacheTags.types';
// export * from './gen_typings';
export * from './extra_typings';

export function getDisplayName(u: User | undefined) {
  return (u && [u.firstName, u.lastName].join(' ')) || '';
}
export function userHasClaim(
  u: UserResponse | undefined,
  claim: string,
  value: string
) {
  let markers = [
    { claim, value },
    { claim: 'ca', value: '1' },
    { claim: 'sa', value: '1' },
  ];

  return markers.some((m) => {
    let { claim, value } = m;
    return u?.claims?.some((x) => x.claim.name === claim && x.value === value);
  });
}

export interface GenericClientQueryRequest {
  clientId: string;
}

export interface ClientRequest {
  clientId?: string;
}
export interface PaginatedRequest extends ClientRequest {
  page?: string | number;
  size?: string | number;
  all?: boolean | string;
}

export interface ClientAdminRequest {
  clientId: string;
}
export interface SomeRequest {
  ids: string[];
}

export type SearchRequest = {
  module: string;
  page: number;
  size: number;
  search: string;
};

export type SearchResponse<T = {}> = {
  items: T[];
  total: number;
};

export interface AuthContext {
  jwt: string;
  refreshToken: string;
  expiresIn: number | undefined;
  user: UserResponse;
}
